var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._g({tag:"component",staticClass:"rounded-lg p-2 px-4 text-center font-semibold hover:bg-opacity-80",class:{
    'opacity-50 cursor-default': _vm.$attrs.disabled,
    'inline-block': _vm.anchor
  }},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }